const timeout = <T = boolean>(ms: number, result: T = true as T) =>
  new Promise<T>(r => setTimeout<[T]>(r, ms, result as T));

export default timeout;
